import React from 'react';
import { LocationIcon } from '../../Basic/Icons/ButtonIcons/ButtonIcons.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import { TooltipContainer, Tooltip } from './TopNavigationTooltip.styles.mjs';
import { useTheme } from 'styled-components';

const TopNavigationTooltip = () => {
    const theme = useTheme();
    return (React.createElement(TooltipContainer, null,
        React.createElement(Tooltip, null,
            React.createElement("div", null,
                React.createElement(LocationIcon, { color: theme.colors.skyBlue }),
                React.createElement(TextComponent, { tag: "span", size: "micro", fontWeight: "medium", color: theme.colors.buttonTextColor }, "Is this not your region? Change it in the menu")))));
};

export { TopNavigationTooltip as default };
//# sourceMappingURL=TopNavigationTooltip.mjs.map
